import React from "react"

import ChangeAPISection from "./ChangeAPISection"

const ChangeAPI = () => (
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line react/jsx-filename-extension
  <div>
    <span>
      Experimental - might not work everywhere, can be overriden in url (uses Cookies if enabled)
    </span>
    <div>
      <ChangeAPISection title="apiUrl (Search, Places)" apiType="apiUrl" />
      <ChangeAPISection title="metaApiUrl (Search - other providers)" apiType="metaApiUrl" />
      <ChangeAPISection title="bookingApiUrl (Booking, manage)" apiType="bookingApiUrl" />
      <ChangeAPISection title="PICI api url (Booking)" apiType="piciApiUrl" />
      <ChangeAPISection title="PICI api url (MMB)" apiType="mmbPiciApiUrl" />
      <ChangeAPISection title="mmbApiUrl (Mambo, new manage calls)" apiType="mmbApiUrl" />
      <ChangeAPISection title="authApiUrl (Auth)" apiType="authApiUrl" />
      <ChangeAPISection title="locationsApiUrl (Locations)" apiType="locationsApiUrl" />
      <ChangeAPISection title="Umbrella (Search)" apiType="umbrellaUrl" />
      <ChangeAPISection title="GraphQL (Multiple services)" apiType="graphqlApiUrl" />
      <ChangeAPISection title="Account API" apiType="accountGraphqlApi" />
      <ChangeAPISection title="MMB 2 Base Path" apiType="mmb2BasePath" />
      <ChangeAPISection title="Prebooking API" apiType="prebookingApiUrl" />
    </div>
  </div>
)

export default ChangeAPI
